import { Controller } from '@hotwired/stimulus';

// Bootstrap 3 の .fade のトランジション（モーダル 300ms、背景 150ms）が終わるまで待ってから隠す
const TRANSITION_DURATION = 300;

// Bootstrap 3 の CSS のまま、jQuery の Bootstrap プラグインと同じクラスを付け外しして開閉する
export default class extends Controller {
  disconnect() {
    if (this.shown) this.hide();
  }

  open() {
    if (this.shown) return;
    this.shown = true;
    // 閉じるトランジションの途中で開き直したときに、前の背景が透明のまま残って画面のクリックを奪わないよう、先に隠し終える
    if (this.hideTimer) this.hide();
    this.trigger = document.activeElement;

    this.adjustBodyPadding();
    document.body.classList.add('modal-open');

    this.backdrop = document.createElement('div');
    this.backdrop.className = 'modal-backdrop';
    if (this.fade) this.backdrop.classList.add('fade');
    document.body.append(this.backdrop);

    this.element.style.display = 'block';
    this.element.scrollTop = 0;
    // 表示した直後に in を付けるとトランジションが起きないので、レイアウトを確定させてから付ける
    this.element.offsetWidth;
    this.element.classList.add('in');
    this.backdrop.classList.add('in');
    this.element.focus();

    this.onKeydown = (event) => {
      if (event.key === 'Escape') this.close();
    };
    // 押し始めも .modal 自身のときだけ閉じ、ダイアログの中で文字を選んで外で離したときに閉じないようにする
    this.onMousedown = (event) => {
      this.pressedOutside = event.target === this.element;
    };
    this.onClick = (event) => {
      if (this.pressedOutside && event.target === this.element) this.close();
    };
    this.element.addEventListener('keydown', this.onKeydown);
    this.element.addEventListener('mousedown', this.onMousedown);
    this.element.addEventListener('click', this.onClick);
    // Bootstrap 3 の enforceFocus と同じく、Tab などでモーダルの外へ出たフォーカスをモーダルへ戻す
    this.onFocusin = (event) => {
      if (!this.element.contains(event.target)) this.element.focus();
    };
    document.addEventListener('focusin', this.onFocusin);
  }

  // action="modal#close"
  close(event) {
    event?.preventDefault();
    if (!this.shown) return;
    this.shown = false;

    this.element.removeEventListener('keydown', this.onKeydown);
    this.element.removeEventListener('mousedown', this.onMousedown);
    this.element.removeEventListener('click', this.onClick);
    document.removeEventListener('focusin', this.onFocusin);

    this.element.classList.remove('in');
    this.backdrop.classList.remove('in');
    this.hideTimer = setTimeout(
      () => this.hide(),
      this.fade ? TRANSITION_DURATION : 0,
    );
  }

  hide() {
    document.removeEventListener('focusin', this.onFocusin);
    clearTimeout(this.hideTimer);
    this.hideTimer = null;
    this.element.style.display = 'none';
    this.backdrop?.remove();
    this.backdrop = null;
    document.body.classList.remove('modal-open');
    document.body.style.paddingRight = this.originalBodyPadding ?? '';
    if (!this.shown) this.trigger?.focus();
  }

  get fade() {
    return this.element.classList.contains('fade');
  }

  // modal-open で body のスクロールバーが消えて画面が横にずれないよう、消えた幅を padding で埋める
  adjustBodyPadding() {
    const scrollbarWidth =
      window.innerWidth - document.documentElement.clientWidth;
    this.originalBodyPadding = document.body.style.paddingRight;
    if (scrollbarWidth <= 0) return;

    const padding = Number.parseFloat(
      getComputedStyle(document.body).paddingRight,
    );
    document.body.style.paddingRight = `${padding + scrollbarWidth}px`;
  }
}
